export default __webpack_public_path__ + "static/media/cc_text.3d2fccfb.svg";